import React from 'react';
import logomark from '../assets/capitol-commons-logomark.svg';

/**
 * The Capitol Commons logomark + wordmark, in one place.
 *
 * The public auth pages each drew their own: a lucide `Building2` glyph inside
 * a purple rounded square, which is a generic building icon, not the brand —
 * on /register and /accept-invitation both. Meanwhile the app shells
 * (Layout's mobile header, ProTabLayout) render the real logomark asset.
 *
 * There are three logo files in assets/ (the 2025 raster, a 2026 raster, and
 * this vector mark). This uses the vector one because it is what the shells
 * already use and it stays crisp at any size — if brand names a different
 * canonical file, change it here and every surface follows.
 */
export interface BrandLockupProps {
  /** Tailwind height class for the mark. Wordmark scales alongside. */
  size?: 'sm' | 'md';
  /** Hide the "Capitol Commons" text and show the mark alone. */
  markOnly?: boolean;
  className?: string;
}

const BrandLockup: React.FC<BrandLockupProps> = ({ size = 'md', markOnly = false, className = '' }) => (
  <div className={`flex items-center gap-3 ${className}`}>
    <img
      src={logomark}
      alt={markOnly ? 'Capitol Commons' : ''}
      aria-hidden={markOnly ? undefined : true}
      className={size === 'sm' ? 'h-7 w-auto' : 'h-9 w-auto'}
    />
    {!markOnly && (
      <span
        className={`font-bold text-text-primary dark:text-text-dark-primary ${
          size === 'sm' ? 'text-lg' : 'text-xl'
        }`}
      >
        Capitol Commons
      </span>
    )}
  </div>
);

export default BrandLockup;
